import { parseYandexURL } from './utils';

const YANDEX_CONTAINER_ID = 'mggp-yandex-ad-container';

export class YandexWrapper {
  constructor(player, onError, onEvent) {
    this.player = player;
    this.config = player.config;
    this.onError = onError;
    this.onEvent = onEvent;
    this.playbackController = null;
    this.yandexContainer = null;
    this.alreadyDisposed = false;
  }

  startProcessing = src => {
    const urlParser = this.config.getURLParser(src);
    let [partnerId, category, refererId] = parseYandexURL(src, urlParser);
    this.alreadyDisposed = false;

    if (partnerId !== undefined && category !== undefined) {
      window.ya.videoAd
        .loadModule('AdLoader')
        // 1)  Создаем экземпляр AdLoader с рекламными параметрами
        .then(module => {
          // if (process.env.NODE_ENV === 'development') {
          //   partnerId = 428563; // test id from yandex
          //   category = 0;
          // }

          let config = {
            partnerId,
            category,
            additionalParams: {
              "partner-stat-id": refererId
            }
          };

          return module.AdLoader.create(config);
        })
        // 2) Загружаем рекламу
        .then(adLoader => {
          return adLoader.loadAd();
        })
        // 4) Запускаем рекламу
        .then(adViewer => {
          if (!this.alreadyDisposed) {
            const videoSlot = this.player.get('ad:vendor:video');

            this.yandexContainer = document.getElementById(YANDEX_CONTAINER_ID);
            if (!this.yandexContainer) {
              const adContainer = document.getElementById('mggp-ad-container');
              const div = document.createElement('div');
              div.style.width = '100%';
              div.style.height = '100%';
              div.style.position = 'relative';
              div.style.zIndex = 2;
              div.id = YANDEX_CONTAINER_ID;
              adContainer.appendChild(div);
              this.yandexContainer = div;
            }

            // Создаем контроллер воспроизведения
            const adPlaybackController = adViewer.createPlaybackController(
              videoSlot,
              this.yandexContainer
            );
            // Запускаем проигрывание рекламы
            adPlaybackController.playAd();

            this.playbackController = adPlaybackController;
            this.onNeedSubscribe(adPlaybackController);
          }
        })
        // Если что-то пошло не так, логируем ошибку в консоль
        .catch(error => {
          this.onError(error);
        });
    } else {
      this.onError();
    }
  };

  onNeedSubscribe = controller => {
    controller.subscribe('AdPodImpression', this.onEvent('AdPodImpression'));
    controller.subscribe('AdPodSkipped', this.onEvent('AdPodSkipped'));
    controller.subscribe('AdPodStarted', this.onEvent('AdPodStarted'));
    controller.subscribe('AdPodStopped', this.onEvent('AdPodStopped'));
    controller.subscribe(
      'AdPodVideoFirstQuartile',
      this.onEvent('AdPodVideoFirstQuartile')
    );
    controller.subscribe(
      'AdPodVideoMidpoint',
      this.onEvent('AdPodVideoMidpoint')
    );
    controller.subscribe(
      'AdPodVideoThirdQuartile',
      this.onEvent('AdPodVideoThirdQuartile')
    );
    controller.subscribe(
      'AdSkippableStateChange',
      this.onEvent('AdSkippableStateChange')
    );
    controller.subscribe('AdStarted', this.onEvent('AdStarted'));
    controller.subscribe('AdStopped', this.onEvent('AdStopped'));
    controller.subscribe(
      'AllAdPodVideoComplete',
      this.onEvent('AllAdPodVideoComplete')
    );
  };

  resume = () => this.playbackController && this.playbackController.resumeAd();
  pause = () => this.playbackController && this.playbackController.pauseAd();
  stop = () => this.playbackController && this.playbackController.stopAd();

  dispose = () => {
    this.stop();
    this.alreadyDisposed = true;
    if (this.yandexContainer && this.yandexContainer.parentNode) {
      this.yandexContainer.parentNode.removeChild(this.yandexContainer);
    }
  };
}
